import languageTemplate from './languagesTemplate';

const { i18n } = victaulicResources;

const itemTemplate = (resource) => {
	const content = {
		resource,
		languages: languageTemplate(
			resource,
			resource.languages,
		),
		add: i18n['Add to Collection'],
		update: i18n['Update Collection'],
	};
	return `
		<div class="vtc-cart-search__resource-item">
			<div class="vtc-cart-search__resource-item-title">${content.resource.title}</div>
			<div class="vtc-cart-search__resource-item-number">${content.resource.number}</div>
			<div class="vtc-cart-search__resource-item-actions">
			<a href="javascript:void(0)" class="js-resource-lang-toggle">
				<i class="mdi mdi-file-document-box-plus-outline" aria-hidden="true"></i>
				${content.add}
			</a>
			<div class="vtc-resource-table-actions-popup">
				<ul class="vtc-resource-collection">
				<li>
					<button role="button" class="js-resource-table-add-group-to-collection vtc-action">
					<i class="fa fa-folder"></i>
					${content.update}
					</button>
				</li>
				${content.languages}
				</ul>
			</div>
			</div>
		</div>
	`;
};

export default itemTemplate;
